




































































import {
  apiSaleAfterWriteOffOrderSaleAfterApply,
  apiSaleAfterWriteOffOrderSaleAfterPreSaleInfo,
} from '@/api'
import { BookComponents } from '../components'
import { computed, ref } from '@vue/composition-api'
import { defineClassComponent, useApi, useQuery } from '@/hooks'
import { mall } from '@/mall_jssdk'
import { navigateBack } from '@/router'
import { submit, Track } from '@/utils'

export default defineClassComponent(
  {
    components: BookComponents,
  },
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '申请退款',
        }))
      }

      query = useQuery<{
        orderNo: string
      }>()

      apiData = useApi(() =>
        apiSaleAfterWriteOffOrderSaleAfterPreSaleInfo({
          orderNo: this.query.orderNo,
        }).then(res => {
          if (res.codeType === 2) {
            this.count.value = res.surplusCount!
          }
          return res
        }),
      )

      pageData = computed(() => this.apiData.data)

      reasonData = computed(() => [
        ...this.pageData.value.reasonList!,
        '其他原因',
      ])

      count = ref(1)

      refundAmount = computed(() =>
        mall.calculator.mul(
          this.count.value,
          this.pageData.value.unitAmount!,
        ),
      )

      reason = ref('')

      reasonDetail = ref('')

      disabled = computed(
        () =>
          !this.reason.value ||
          (this.reason.value === '其他原因' && !this.reasonDetail.value),
      )

      handleRequestClick = () => {
        submit(async $ => {
          $.start('提交中...')
          await apiSaleAfterWriteOffOrderSaleAfterApply({
            orderNo: this.query.orderNo,
            quantity: this.count.value,
            reason:
              this.reason.value === '其他原因'
                ? this.reasonDetail.value
                : this.reason.value,
          })
          await $.success('申请提交成功')
          navigateBack()
        })
      }
    },
)
